<template>
  <v-container fluid>
    <!-- <template>
      <div style="background-color: rgb(118 126 137);">
        <v-breadcrumbs :items="breadcrumbs">
            <template v-slot:divider>
                <v-icon>mdi-forward</v-icon>
            </template>
        </v-breadcrumbs>
      </div>
    </template> -->

    <v-row class="mt-2">
      <v-col cols="12">
        <v-card dark outlined>
          <v-card-title class="secondary py-1 text-subtitle-1">
            <v-icon left dense> mdi-flag </v-icon>
            Event Configuration
            <v-spacer />
          </v-card-title>

          <v-card-text>
            <v-form ref="form" lazy-validation>
              <v-text-field
                v-model="editedItem.EventName"
                label="Event Name"
                :rules="eventNameRules"
                required
              ></v-text-field>

              <!-- event start/end date time -->
              <v-row>
                <v-col cols="6">
                  <v-datetime-picker
                    label="Event Start Date"
                    v-model="startDate"
                    :text-field-props="textFieldPropsDate"
                    :date-picker-props="datePropsDate"
                    :time-picker-props="timePropsDate"
                    date-format="dd/MM/yyyy"
                  />
                </v-col>
                <v-col cols="6">
                  <v-datetime-picker
                    label="Event End Date"
                    v-model="endDate"
                    :text-field-props="textFieldPropsDate"
                    :date-picker-props="datePropsDate"
                    :time-picker-props="timePropsDate"
                    date-format="dd/MM/yyyy"
                  />
                </v-col>
              </v-row>
              <!-- event start/end date time -->
              <v-combobox
                v-model="editedItem.ShowInPOS"
                :items="POSTypes"
                label="Show in POS"
                :rules="[(v) => !!v || 'Show in POS is required']"
                required
              ></v-combobox>

              <v-combobox
                v-model="editedItem.StallholdersCanChangeHeadcount"
                :items="POSTypes"
                label="Stallholders can change headcount"
                :rules="[
                  (v) =>
                    !!v || 'Stallholders can change headcount is required',
                ]"
                required
              ></v-combobox>

              <v-text-field
                v-model="editedItem.GSTSurchargePercentage"
                label="GST Percentage"
                type="number"
                :rules="CSTSPercentageRules"
                required
              ></v-text-field>

              <v-text-field
                v-model="editedItem.CardSurchargePercentage"
                label="Card Surcharge Percentage"
                type="number"
                :rules="CSPercentageRules"
                required
              ></v-text-field>

              <v-row class="mb-2">
                <v-col>
                  <label>Payment Profile</label>
                  <v-row class="ml-1">
                    <v-checkbox
                      v-model="editedItem.PaymentProfile"
                      label="Cash"
                      value="Cash"
                      class="mr-5"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="editedItem.PaymentProfile"
                      label="Card"
                      value="Card"
                      class="mr-5"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="editedItem.PaymentProfile"
                      label="Voucher"
                      value="Voucher"
                    ></v-checkbox>
                  </v-row>
                </v-col>
              </v-row>

              <label>Printing Profile</label>
              <v-row class="ml-1">
                <div v-for="item in PrintingList" :key="item.id">
                  <v-checkbox
                    v-model="editedItem.PrintingProfile"
                    :label="item.name"
                    :value="item.name"
                    class="mr-5"
                    :rules="eventPrintRules"
                    required
                  ></v-checkbox>
                </div>
              </v-row>

              <v-combobox
                v-model="editedItem.StandardDrinkLimitEnforce"
                :items="EnforceTypes"
                item-text="name"
                label="Drink Limit Profile"
                :return-object="false"
                required
              ></v-combobox>

              <v-text-field
                v-model="editedItem.StandardDrinkLimit"
                label="Maximum Drink Limit"
                type="number"
                min="0"
                :rules="StandardDrinkLimitRules"
                required
              ></v-text-field>

              <v-text-field
                v-model="editedItem.Username"
                label="Terminal Username"
                :rules="usernameRules"
                required
              ></v-text-field>

              <v-text-field
                v-model="editedItem.Password"
                label="Terminal Password"
                :rules="passwordRules"
                required
              ></v-text-field>

              <!-- <v-combobox
                v-model="editedItem.StallTags"
                label="Stall Tags"
                chips
                multiple
                closable-chips
                small-chips
                @keydown.enter.prevent
              >
                <template v-slot:selection="{ attrs, item, select, selected }">
                  <v-chip
                    v-bind="attrs"
                    :input-value="selected"
                    close
                    @click="select"
                    @click:close="removeStallTag(item)"
                    :color="
                      $generateColors.getColor(
                        editedItem.StallTags.indexOf(item)
                      )
                    "
                    dark
                  >
                    {{ item }}
                  </v-chip>
                </template>
              </v-combobox>
              <v-combobox
                v-model="editedItem.ProductTags"
                label="Product Tags"
                chips
                multiple
                closable-chips
                small-chips
                @keydown.enter.prevent
              >
                <template v-slot:selection="{ attrs, item, select, selected }">
                  <v-chip
                    v-bind="attrs"
                    :input-value="selected"
                    close
                    @click="select"
                    @click:close="removeProductTag(item)"
                    :color="
                      $generateColors.getColor(
                        editedItem.ProductTags.indexOf(item)
                      )
                    "
                    dark
                  >
                    {{ item }}
                  </v-chip>
                </template>
              </v-combobox> -->

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  text
                  :disabled="saving"
                  @click="handleClickCancel()"
                >
                  Cancel
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  :loading="saving"
                  :disabled="saving"
                  @click="submitForm"
                >
                  Submit
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-overlay :value="saving" z-index="300">
      <div class="text-center">
        <v-progress-circular indeterminate size="64" color="primary" />
        <div class="mt-4 white--text text-h6">
          {{ Action === "create" ? "Creating Event…" : "Saving Event…" }}
        </div>
        <div class="mt-1 white--text text-caption">
          Setting up the transactions table — this can take a moment
        </div>
      </div>
    </v-overlay>
  </v-container>
</template>

<script>
import moment from "moment";
import "izitoast/dist/css/iziToast.min.css"; // loading css
import iziToast from "izitoast/dist/js/iziToast.min.js"; // access to iziToast now
import { mapActions, mapState, mapMutations } from "vuex";
export default {
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    eventData: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    textFieldPropsDate: {
      appendIcon: "event",
    },
    datePropsDate: {
      headerColor: "black",
    },
    timePropsDate: {
      useSeconds: false,
      ampmInTitle: true,
    },
    breadcrumbs: [
      {
        text: "Events",
        disabled: false,
        href: "/StallholdersStallsStaffTerminals",
      },
      {
        text: "Events Configuration",
        disabled: true,
        href: "",
      },
    ],

    Action: "",
    saving: false,
    editedItem: {
      EventName: "",
      Year: "",
      ShowInPOS: "Yes",
      StallholdersCanChangeHeadcount: "No",
      GSTSurchargePercentage: 10,
      CardSurchargePercentage: 0,
      PaymentProfile: [],
      PrintingProfile: "",
      StandardDrinkLimitEnforce: "Prompt",
      StandardDrinkLimit: "",
      Username: "",
      Password: "",
      StartDateTime: "",
      EndDateTime: "",
      StallTags: [],
      ProductTags: [],
    },
    PrintingList: [
      {
        id: 1,
        name: "Print",
      },
      {
        id: 2,
        name: "Prompt",
      },
      {
        id: 3,
        name: "Bypass",
      },
    ],

    POSTypes: ["Yes", "No"],

    EnforceTypes: [
      { id: true, name: "Enforce" },
      { id: false, name: "Prompt" },
    ],

    eventNameRules: [(v) => !!v || "Event Name is required"],
    usernameRules: [(v) => !!v || "Username is required"],
    passwordRules: [
      (v) => !!v || "Password is required",
      (v) => /().{4,}/.test(v) || "Password must contain at least 4 characters",
    ],
    eventPrintRules: [(v) => !!v || "Printing Profile is required"],
    CSPercentageRules: [
      (v) =>
        v >= 0 ||
        "Card Surcharge (%) must exist and be equal or greater than 0",
    ],
    CSTSPercentageRules: [
      (v) =>
        v >= 0 || "GST Percentage must exist and be equal to greater than 0",
    ],
    StandardDrinkLimitRules: [
      (v) =>
        (v && v >= 0) ||
        "Maximum Drink Limit must exist and be equal to or greater than 0",
    ],

    // Internal date properties for computed dates
    internalStartDate: new Date(),
    internalEndDate: new Date(),
  }),
  computed: {
    ...mapState("filter", ["AllStalls"]),

    startDate: {
      get() {
        return this.internalStartDate;
      },
      set(val) {
        this.internalStartDate = val;
      },
    },

    endDate: {
      get() {
        return this.internalEndDate;
      },
      set(val) {
        this.internalEndDate = val;
      },
    },
  },

  created() {
    // Disable event selector while on this page
    this.setEventSelectorDisabled(true);

    if (this.id && this.id !== "0") {
      if (this.eventData) {
        // Use props data when available
        this.editItem(this.eventData);
        this.internalStartDate = moment(
          this.eventData.startDateTime,
          "YYYYMMDDHHmm"
        ).toDate();
        this.internalEndDate = moment(
          this.eventData.endDateTime,
          "YYYYMMDDHHmm"
        ).toDate();
        this.Action = "update";
      } else {
        console.warn("Event data not provided via props for edit mode");
        this.Action = "update";
      }
    } else {
      this.Action = "create";
      // Set default dates for new events
      this.internalStartDate = new Date();
      this.internalEndDate = new Date();
    }
  },

  mounted() {
    // Ensure event selector is disabled while on this page
    this.setEventSelectorDisabled(true);
  },

  beforeDestroy() {
    // Re-enable event selector when leaving this page
    this.setEventSelectorDisabled(false);

    // Clean up any old localStorage data that might still exist
    localStorage.removeItem("setEventObj");
  },
  methods: {
    ...mapActions("admin", [
      "createEvent",
      "getEventManagement",
      "getEventsData",
    ]),
    ...mapActions("filter", ["initialLogin"]),
    ...mapMutations("admin", ["setEventSelectorDisabled"]),

    // WHAT WAS THIS SUPPOSED TO DO? - Skips comment
    // haddleClickUpdate: function (obj) {
    //     let paramObj = {}
    //     paramObj.Type = 'event',
    //     paramObj.id = obj.EventId
    //     try {
    //         this.getEventManagement(paramObj).then(response => {
    //             console.log("response")
    //             console.log(response)
    //         }).catch(err => {
    //             console.log("err")
    //             console.log(err)
    //         })
    //     } catch (e) {
    //       console.log(e)
    //     }
    // },

    editItem: function (eventObj) {
      this.editedItem = eventObj;
      console.log("created() eventObj", eventObj);
      this.editedItem.StandardDrinkLimitEnforce =
        this.editedItem.StandardDrinkLimitEnforce === true
          ? "Enforce"
          : "Prompt";
      this.editedItem.ShowInPOS =
        this.editedItem.ShowInPOS === true ? "Yes" : "No";
      this.editedItem.StallholdersCanChangeHeadcount =
        this.editedItem.StallholdersCanChangeHeadcount === true ? "Yes" : "No";
    },

    submitForm: function () {
      // console.log("submitForm() this.editedItem", this.editedItem);
      // console.log("submitForm() this.allStallHolders", this.allStallHolders);
      try {
        if (this.$refs.form.validate()) {
          this.editedItem.Year = this.internalStartDate
            .getFullYear()
            .toString();

          this.editedItem.startDateTime = moment(this.internalStartDate).format(
            "YYYYMMDDHHmm"
          );
          this.editedItem.endDateTime = moment(this.internalEndDate).format(
            "YYYYMMDDHHmm"
          );

          this.editedItem.StandardDrinkLimitEnforce =
            this.editedItem.StandardDrinkLimitEnforce === "Enforce"
              ? true
              : false;
          this.editedItem.ShowInPOS =
            this.editedItem.ShowInPOS === "Yes" ? true : false;
          this.editedItem.StallholdersCanChangeHeadcount =
            this.editedItem.StallholdersCanChangeHeadcount === "Yes"
              ? true
              : false;

          let event_item = [
            {
              Type: "Event",
              Action: this.Action,
              Properties: this.editedItem,
            },
          ];

          let submitEvent = {
            event_items: event_item,
          };

          this.saving = true;
          this.createEvent(submitEvent)
            .then((response) => {
              iziToast.success({
                title: "Event",
                message: "Successfully inserted record!",
                position: "topRight",
              });

              console.log("response");
              console.log(response);
              this.redirectReload();
            })
            .catch((err) => {
              console.log("err");
              console.log(err);
              iziToast.warning({
                title: "Event",
                message: "Fail to inserted record!",
                position: "topRight",
              });
            })
            .finally(() => {
              this.saving = false;
            });
        }
      } catch (e) {
        this.saving = false;
        console.log(e);
      }
    },
    redirectReload() {
      this.getEventsData(this.editedItem.Year).then(() => {
        console.log(
          "Can Create event return eventId?",
          "As we could set the newly created event as current event"
        );
      });

      this.initialLogin().then((response) => {
        console.log("Do we need this?", response);
      });
      this.$router.push({ name: "EventManagement" });
    },
    handleClickCancel: function () {
      this.$router.push({ name: "EventManagement" });
    },
    removeStallTag(tag) {
      this.editedItem.StallTags = this.editedItem.StallTags.filter(
        (t) => t !== tag
      );
    },
    removeProductTag(tag) {
      this.editedItem.ProductTags = this.editedItem.ProductTags.filter(
        (t) => t !== tag
      );
    },
  },
};
</script>
